export default "__VITE_ASSET__d2555e05__"